export enum StripeActionType {
  UpdateSubscriptionPaymentMethod = 'update_subscription_payment_method',
  UpdateAutomaticPaymentMethod = 'update_automatic_payment_method',
}
